import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { MockScenarioService } from '../mocks/mock-scenario.service';
import { MockScenarioId, MockScenarioState } from '../mocks/mock-scenarios';

@Component({
  selector: 'app-debug-panel',
  templateUrl: './debug-panel.component.html',
  styleUrls: ['./debug-panel.component.css']
})
export class DebugPanelComponent implements OnInit, OnDestroy {
  showPanel = false;
  readonly debugEnabled = environment.enableMockTools;
  state: MockScenarioState;

  private stateSubscription?: Subscription;

  constructor(public mockScenarioService: MockScenarioService) {
    this.state = this.mockScenarioService.snapshot;
  }

  get scenarios() {
    return this.mockScenarioService.scenarios;
  }

  ngOnInit(): void {
    this.stateSubscription = this.mockScenarioService.state.subscribe((state) => {
      this.state = state;
    });
  }

  ngOnDestroy(): void {
    this.stateSubscription?.unsubscribe();
  }

  togglePanel(): void {
    this.showPanel = !this.showPanel;
  }

  useRealApi(): void {
    this.mockScenarioService.setUseRealApi(true);
  }

  useMockScenario(scenarioId: MockScenarioId): void {
    this.mockScenarioService.setScenario(scenarioId);
  }

  updateLatency(rawLatency: string): void {
    this.mockScenarioService.setLatencyMs(Number(rawLatency));
  }

  reset(): void {
    this.mockScenarioService.reset();
  }
}
